var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "crud-label-container", class: _vm.classList },
    [
      _c("label", { staticClass: "crud-label" }, [
        _vm._v(_vm._s(_vm.label) + " "),
        _vm.labelHint
          ? _c("img", {
              attrs: {
                src: require(`@/common/assets/icons/help-white-text.svg`),
                title: _vm.labelHint,
                alt: "hint"
              }
            })
          : _vm._e(),
        _vm.subLabel ? _c("span", [_vm._v(_vm._s(_vm.subLabel))]) : _vm._e()
      ]),
      _vm.hasCheckBox
        ? _c("InnerCheckbox", {
            attrs: { checkboxData: _vm.checkboxData },
            on: { valueHasChanged: _vm.valueHasChanged }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }